import { useCallback, useState, useRef } from 'react'
import { COLORS, TYPE } from './tokens'

// Drag-drop + click-to-browse for a single PDF file.
// Parent owns validation and PDF text extraction.
export default function Dropzone({ onFile, disabled, label = 'Drop a policy PDF here', hint = 'or click to browse' }) {
  const inputRef = useRef(null)
  const [dragging, setDragging] = useState(false)

  const handleDrop = useCallback((e) => {
    e.preventDefault()
    setDragging(false)
    if (disabled) return
    const file = e.dataTransfer?.files?.[0]
    if (file) onFile?.(file)
  }, [disabled, onFile])

  const handlePick = useCallback((e) => {
    const file = e.target.files?.[0]
    if (file) onFile?.(file)
    if (inputRef.current) inputRef.current.value = ''
  }, [onFile])

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setDragging(true) }}
      onDragLeave={() => setDragging(false)}
      onDrop={handleDrop}
      onClick={() => !disabled && inputRef.current?.click()}
      style={{
        height: '200px',
        border: `1.5px dashed ${dragging ? COLORS.accent : COLORS.hairline}`,
        borderRadius: '8px',
        background: dragging ? 'rgba(138, 208, 214, 0.06)' : 'rgba(255,255,255,0.5)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        transition: 'all 120ms ease'
      }}
    >
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke={COLORS.mutedText} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: '16px' }}>
        <path d="M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242" />
        <path d="M12 12v9" />
        <path d="m16 16-4-4-4 4" />
      </svg>
      <div style={{ ...TYPE.lead, color: COLORS.bodyText, marginBottom: '4px' }}>{label}</div>
      <div style={{ ...TYPE.body, color: COLORS.mutedText }}>{hint}</div>
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf"
        onChange={handlePick}
        style={{ display: 'none' }}
      />
    </div>
  )
}
